export default __webpack_public_path__ + "static/media/cow_chicken_gray.040c1333.svg";